import { render, staticRenderFns } from "./StocktakingProductImage.vue?vue&type=template&id=405168b0&scoped=true&"
import script from "./StocktakingProductImage.vue?vue&type=script&lang=js&"
export * from "./StocktakingProductImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405168b0",
  null
  
)

export default component.exports